import React from "react";
import '../../App.css'
import HistoryComp from "../HistoryComp";

function History(){
    return (
        <>
        
            <HistoryComp></HistoryComp>
            
            

        </>
    )
}

export default History